import * as types from './types'
import ThemeBuilder from '@/common/utils/theme-builder'

export const mutations = {
	[types.SET_CURRENT_SITE] (state, site) {
		state.site = site
		ThemeBuilder.build(state.site.theme)
	},
	[types.CLEAR_CURRENT_SITE] (state) {
		state.site = null
	}
}



// WEBPACK FOOTER //
// ./src/common/store/Site/mutations.js